import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Heading, Text } from '@chakra-ui/react'

import { Item } from 'appTypes/mapper'
import { ButtonWhite } from 'components/ui/Buttons/Button'
import { getImageUrl } from 'utils/getProductImageUrl'
import { normalizeUrl } from 'utils/normalizeUrl'
import { trimStringToLength } from 'utils/trimStringToLength'

import { CardSimple } from '../Card/CardSimple'

import { BundleItems, StyledCard } from './styles'

type Props = {
  bundle: Item
}

const ProductBundle = ({ bundle }: Props): JSX.Element => {
  const { t } = useTranslation('common')

  return (
    <StyledCard>
      <Box>
        <Heading as="h3" fontSize="lg" fontWeight="400" lineHeight={{ base: 1.33, md: 1.2 }}>
          {bundle.name}
        </Heading>
        <Text fontSize="sm" marginTop="8px" fontWeight="300">
          {trimStringToLength(bundle.description || '')}
        </Text>
        <Text fontSize="md" marginTop="8px">
          {bundle.pricePerDay} {t('nokPerDay')}
        </Text>
        {bundle.discount && (
          <Text color="green.a200" fontSize="sm">
            {t('youSaveUpTo')} {bundle.discount}%
          </Text>
        )}
        <BundleItems>
          {bundle.products.map((product) => (
            <CardSimple key={product.id} name={product.name} imageUrl={getImageUrl(product.images ?? [])} />
          ))}
        </BundleItems>
      </Box>

      <ButtonWhite as={`/bundles/${normalizeUrl(bundle.name, bundle.id)}`} href="/bundles/[name]">
        {t('rentIt')}
      </ButtonWhite>
    </StyledCard>
  )
}

export default ProductBundle
